import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import loyaltyModule from "@/store/modules/Sale/loyalty-module";
import cashupsModule from "@/store/modules/finance/cashups-module";
import stockModule from "./modules/stock/stock-module";
import vatCalculator from "./modules/finance/vat_calculator";
import specialsModule from "./modules/stock/specials-module";
import stockReceiveModule from "./modules/stock/stock-received-module";
import supplierModule from "./modules/supplier-module";
import debtorModule from "./modules/Accounts/debtor-module";
import userModule from "./modules/employee/user-module";
import emailModule2 from "@/store/modules/email-module";
import securitiesModule from "./modules/employee/securities-module";
import stockCategoryModule from './modules/stock/stockcategory-module';
import taxModule from './modules/tax-module';
import emailModule from './modules/Accounts/email-module';
import timeModule from './modules/time-module';
import reportsModule from './modules/report-module';
import stockTakeModule from './modules/stock/stock-take-module'
import stockLinkingModule from "./modules/stock/stock-linking-module";
import stockTransferModule from './modules/stock/stock-transfer-module'
import safeModule from './modules/finance/safes-module'
import expenseModule from './modules/finance/expense-module'
import AssetsModule from  './modules/finance/asset-module'
import cookingInstruction from './modules/stock/cooking-instructions-module'
import billingModule from './modules/billing-module'
import mainDebtorModule from './modules/Accounts/main-debtor-module'
import floatModule from './modules/employee/float-module'
import currencyModule from './modules/finance/currency-module'
import paymentMethodsModule from './modules/finance/payment-methods-module'
import settingsModule from './modules/settings-module'
import coaModule from './modules/finance/chart-of-accounts'
import deliveryNotesModule from './modules/Accounts/delivery-notes-module'
import ticketModule from './modules/ticket-module'
import router from "../router";
import {Storage} from "@/Services/Storage";
import {LytningService} from "@/Services/LytningService";
import Swal from "sweetalert2";
import CashupsModule from "@/store/modules/finance/cashups-module";
import ticket_notes_module from "@/store/modules/ticket_notes_module";
import subscriptionModule from "@/store/modules/subscription-module";
import networkModule from "./modules/network";
import tallyReports from './modules/reports/tally-reports-module'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        loading: false,
        isUpdateAvailable: false,
        totalExpenseCost: 0, // Holds the total expense
        production: false,
        otherExpenses: [],
        allStores: [],
        newLocalId:null,
        currentStore: null,
        isSmartInvoicing: false,
    },
    getters: {
        getTotalExpenseCost(state) {
            return state.totalExpenseCost;
        },
        getOtherExpenses: (state) => state.otherExpenses,
        getNewStoreLocalId: (state) => state.newLocalId,
        currentDate: () => {
            let date = new Date();
            return date.toISOString().split('T')[0];
        },
        getUpdateAvailability: (state) => state.isUpdateAvailable,
        getSmartInvoicingStatus: (state) => state.isSmartInvoicing,
        getProduction: (state) => state.production,
        currentTime: () => {
            let date = new Date();
            let d = date.toISOString().split('T')[0]
            let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            let t = hour + ':' + minute;
            return d + `T` + t;
        },
        getLoadingState: (state) => state.loading,
        getAllStores: (state) => state.allStores,
        getCurrentStore: (state) => state.currentStore,
        detectOS() {
            let platform = navigator.platform.toLowerCase();
            let userAgent = navigator.userAgent.toLowerCase();
            if (platform.includes('win')) {
                return 'Windows';
            } else if (/android/.test(userAgent)) {
                return 'Android';
            } else if (platform.includes('mac') || userAgent.includes('mac os')) {
                return 'MacOS';
            } else if (platform.includes('linux')) {
                return 'Linux';
            } else if (/iphone|ipad|ipod/.test(userAgent)) {
                return 'iOS';
            } else {
                return 'Unknown OS';
            }
        },
    },
    mutations: {
        setTotalExpenseCost(state, total) {
            state.totalExpenseCost = total;
        },
        addNewStoreLocalId:(state, payload) => state.newLocalId = payload,
        clearNewStoreLocalId:(state) => state.newLocalId = null,
        setUpdateAvailability: (state, payload) => state.isUpdateAvailable = payload,
        setSmartInvoicingStatus: (state, payload) => state.isSmartInvoicing = payload,
        setLoadingState: (state, payload) => state.loading = payload,
        setMobileUser: (state, payload) => Storage.setMobileUser(payload),
        setAllStores: async (state, payload) => {
            if (payload) await Storage.setAllStores(payload)
            else payload = await Storage.getAllStores();
            state.allStores = payload ? payload : [];
        },
        SET_OTHER_EXPENSES(state, expenses) {
            state.otherExpenses = expenses;
        },
        ADD_OTHER_EXPENSE(state, expense) {
            state.otherExpenses.push(expense);
        },

        setCurrentStore: async (state, payload) => {
            if (payload) await Storage.setCurrentStore(payload)
            else payload = await Storage.getCurrentStore();
            state.currentStore = payload;
        },
    },
    actions: {
        /**
         * Initialize the application store.
         * Alias for refreshState to keep backward compatibility with components dispatching 'initializeStore'.
         * @param {Object} context - Vuex action context
         * @returns {Promise<void>}
         */
        async initializeStore(context) {
            return context.dispatch('refreshState');
        },
        refreshState: async (context) => {
            let validate = await context.dispatch(`validatePCRegistration`);
            if (!validate.success) {
                return responses.throwErr(validate.message)
                    .then(() => {
                        return context.dispatch(`clearStoreState`)
                            .then(async () => {
                                let deviceID = await Storage.getDeviceID();
                                localStorage.clear();
                                await Storage.setDeviceID(deviceID)
                                try {
                                    await this.$router.push({name: 'login'})
                                } catch (e) {
                                }
                                return window.location.reload(true);
                            });
                    });
            }
            let promiseArray = [
                context.commit(`setAllStores`),
                context.commit(`setCurrentStore`),
                context.commit(`setCurrentUser`),
            ];
            let storeDB = await Storage.getCurrentStoreDB();
            if (storeDB) {
                promiseArray.push(
                    context.dispatch(`getExpiryDateByCustomerID`),
                    context.dispatch(`updateToLatestVersion`),
                     context.dispatch(`getAllTaxLabels`),
                    context.dispatch(`getAllUsers`),
                    context.dispatch(`getAllSecurities`),
                    context.dispatch(`getCategories`),
                    context.dispatch(`getAllCurrencies`),
                    context.dispatch(`checkSmartInvoicing`),
                    context.dispatch(`getBaseCurrency`),
                    context.dispatch(`isLoyaltyActivated`),
                    context.dispatch(`getKazangDetails`),
                    context.dispatch(`getStoreProductId`),
                    context.dispatch(`getAllPaymentMethods`),
                    // context.dispatch(`getZraSupportedCountries`)
                )
                context.dispatch(`getZraSupportedCountries`).catch(err => {/* console.error('ZRA countries error:', err) */});
            }
            return Promise.all(promiseArray).catch(err => {/* console.error(err) */});
        },
        mobileUserLogin: (context, payload) => {
            return axios.post(backOfficeTomcatApi + `mobileUser/login`, payload)
                .then(({data}) => {
                    return Promise.all([
                        context.commit(`setMobileUser`, payload),
                        context.commit(`setAllStores`, data),
                 ])

                }).catch(err => errorHandler.tomcatError(err));
        },
        setOtherExpenses({ commit }, expenses) {
            commit("SET_OTHER_EXPENSES", expenses);
        },
        addOtherExpense({ commit }, expense) {
            commit("ADD_OTHER_EXPENSE", expense);
        },
        updateTotalExpenseCost({ commit }, total) {
            commit('setTotalExpenseCost', total);
        },
        loginToStore2: async (context, storePayload) => {
            await context.commit('setCurrentStore', storePayload);
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `other/getExpiryDate?Database=` + storeDB)
                .then(async ({data}) => {
                    let expireDate = new Date(data);
                    let today = new Date();
                    if (expireDate < today) {
                        // return responses.showWarning(`System Expired!`);
                        return Swal.fire({
                            title: `System Expired ! `,
                            icon: `error`,
                            html: `<p>Please make payment to continue</p>`,
                            showCancelButton: true,
                            confirmButtonText: `Continue`,
                            showLoaderOnConfirm: true,
                            preConfirm: async () => {
                                return context.dispatch(`getPaymentRoute`);
                            }
                        }).then(() => {
                            return Swal.fire({
                                title: `System Expired ! `,
                                icon: `info`,
                                html: `<p>You will be logged out</p> 
                                       <span>You can login again after making payment</span>
                                      `,
                            }).then(() => {
                                return context.dispatch(`clearStoreState`)
                                    .then(async () => {
                                        let deviceID = await Storage.getDeviceID();
                                        localStorage.clear();
                                        await Storage.setDeviceID(deviceID)
                                        try {
                                            await this.$router.push({name: 'login'})
                                        } catch (e) {
                                        }
                                        return window.location.reload(true);
                                    });
                            });
                        })
                    }
                    return context.dispatch(`refreshState`)
                .then(() => router.push({name: 'StoreTologin'}));
                });
        },
        loginToStore: async (context, storePayload) => {
            await context.commit('setCurrentStore', storePayload);

            // Check if THIS specific store is on Lyt-ning platform
            // Only block if the store being accessed is Lyt-ning, allow all other stores
            const mainCustomerID = storePayload.mainCustomerID;
            const customerId = storePayload.CustomerID;
            if (mainCustomerID && customerId) {
                try {
                    const isLytningStore = await LytningService.isStoreLytning(mainCustomerID, customerId);
                    if (isLytningStore) {
                        // Show message and logout - this specific store is on Lyt-ning
                        await Swal.fire({
                            title: 'Lyt-ning Store Detected',
                            icon: 'warning',
                            html: '<p>This store is on the Lyt-ning platform.</p><p>Please use the Lytning platform to access this store.</p>',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#3085d6'
                        });

                        // Clear state and logout
                        await context.dispatch('clearStoreState');
                        try {
                            await router.push({name: 'login'});
                        } catch (e) {
                            // Router push might fail if already on login page
                        }
                        return;
                    }
                } catch (error) {
                    // If check fails, log error but allow user to proceed
                    console.error('Lyt-ning store check failed:', error);
                }
            }

            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `other/getExpiryDate?Database=` + storeDB)
                .then(async ({data}) => {
                    let expireDate = new Date(data);
                    let today = new Date();
                    if (expireDate < today) {
                        // return responses.showWarning(`System Expired!`);
                        return Swal.fire({
                            title: `System Expiredyou ! `,
                            icon: `error`,
                            html: `<p>Please make payment to continue</p>`,
                            showCancelButton: true,
                            confirmButtonText: `Continue`,
                            showLoaderOnConfirm: true,
                            preConfirm: async () => {
                                return context.dispatch(`getPaymentRoute`);
                            }
                        }).then(() => {
                            return Swal.fire({
                                title: `System Expired ! `,
                                icon: `info`,
                                html: `<p>You will be logged out</p> 
                                       <span>You can login again after making payment</span>
                                      `,
                            }).then(() => {
                                return context.dispatch(`clearStoreState`)
                                    .then(async () => {
                                        let deviceID = await Storage.getDeviceID();
                                        localStorage.clear();
                                        await Storage.setDeviceID(deviceID)
                                        try {
                                            await this.$router.push({name: 'login'})
                                        } catch (e) {
                                        }
                                        return window.location.reload(true);
                                    });
                            });
                        })
                    }
                    return context.dispatch(`refreshState`)
                        .then(() => router.push({name: 'userLogin'}));
                });
        },
        loginToStoreFromFranchise2: async (context, storePayload) => {
            await context.commit('setCurrentStore', storePayload);

            // Check if THIS specific store is on Lyt-ning platform
            // Only block if the store being accessed is Lyt-ning, allow all other stores
            const mainCustomerID = storePayload.mainCustomerID;
            const customerId = storePayload.CustomerID;
            if (mainCustomerID && customerId) {
                try {
                    const isLytningStore = await LytningService.isStoreLytning(mainCustomerID, customerId);
                    if (isLytningStore) {
                        await Swal.fire({
                            title: 'Lyt-ning Store Detected',
                            icon: 'warning',
                            html: '<p>This store is on the Lyt-ning platform.</p><p>Please use the Lytning platform to access this store.</p>',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#3085d6'
                        });
                        await context.dispatch('clearStoreState');
                        try {
                            await router.push({name: 'login'});
                        } catch (e) {}
                        return;
                    }
                } catch (error) {
                    console.error('Lyt-ning store check failed:', error);
                }
            }

            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `other/getExpiryDate?Database=` + storeDB)
                .then(async ({data}) => {
                    let expireDate = new Date(data);
                    let today = new Date();
                    if (expireDate < today) {
                        // return responses.showWarning(`System Expired!`);
                        return Swal.fire({
                            title: `System Expired ! `,
                            icon: `error`,
                            html: `<p>Please make payment to continue</p>`,
                            showCancelButton: true,
                            confirmButtonText: `Continue`,
                            showLoaderOnConfirm: true,
                            preConfirm: async () => {
                                return context.dispatch(`getPaymentRoute`);
                            }
                        }).then(() => {
                            return Swal.fire({
                                title: `System Expired ! `,
                                icon: `info`,
                                html: `<p>You will be logged out</p> 
                                       <span>You can login again after making payment</span>
                                      `,
                            }).then(() => {
                                return context.dispatch(`clearStoreState`)
                                    .then(async () => {
                                        let deviceID = await Storage.getDeviceID();
                                        localStorage.clear();
                                        await Storage.setDeviceID(deviceID)
                                        try {
                                            await this.$router.push({name: 'login'})
                                        } catch (e) {
                                        }
                                        return window.location.reload(true);
                                    });
                            });
                        })
                    }
                    return context.dispatch(`refreshState`)
                        .then(() => router.push({name: 'FranchiseFinance'}));
                });
        },
        loginToStoreFromFranchise: async (context, storePayload) => {
            await context.commit('setCurrentStore', storePayload);

            // Check if customer has any Lyt-ning subscription
            const mainCustomerID = storePayload.mainCustomerID;
            if (mainCustomerID) {
                try {
                    const hasLytningSubscription = await LytningService.checkLytningSubscription(mainCustomerID);
                    if (hasLytningSubscription) {
                        await Swal.fire({
                            title: 'Lyt-ning Subscription Detected',
                            icon: 'warning',
                            html: '<p>Your account has a Lyt-ning subscription.</p><p>Please use the Lytning platform to access your stores.</p>',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#3085d6'
                        });
                        await context.dispatch('clearStoreState');
                        try {
                            await router.push({name: 'login'});
                        } catch (e) {}
                        // return window.location.reload(true);
                    }
                } catch (error) {
                    console.error('Lyt-ning subscription check failed:', error);
                }
            }

            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `other/getExpiryDate?Database=` + storeDB)
                .then(async ({data}) => {
                    let expireDate = new Date(data);
                    let today = new Date();
                    if (expireDate < today) {
                        // return responses.showWarning(`System Expired!`);
                        return Swal.fire({
                            title: `System Expired ! `,
                            icon: `error`,
                            html: `<p>Please make payment to continue</p>`,
                            showCancelButton: true,
                            confirmButtonText: `Continue`,
                            showLoaderOnConfirm: true,
                            preConfirm: async () => {
                                return context.dispatch(`getPaymentRoute`);
                            }
                        }).then(() => {
                            return Swal.fire({
                                title: `System Expired ! `,
                                icon: `info`,
                                html: `<p>You will be logged out</p> 
                                       <span>You can login again after making payment</span>
                                      `,
                            }).then(() => {
                                return context.dispatch(`clearStoreState`)
                                    .then(async () => {
                                        let deviceID = await Storage.getDeviceID();
                                        localStorage.clear();
                                        await Storage.setDeviceID(deviceID)
                                        try {
                                            await this.$router.push({name: 'login'})
                                        } catch (e) {
                                        }
                                        return window.location.reload(true);
                                    });
                            });
                        })
                    }
                    return context.dispatch(`refreshState`)
                        .then(() => router.push({name: 'Support'}));
                });
        },

        selectstoretoadd: async (context, storePayload) => {
    await context.commit('setCurrentStore', storePayload);
              await context.dispatch(`refreshState`)
                .then(async ({data}) => {
            // console.log(data,"hello new data")
         });
},
        loginToStoreFrmFranchise: async (context, storePayload) => {
            await context.commit('setCurrentStore', storePayload);

            // Check if customer has any Lyt-ning subscription
            const mainCustomerID = storePayload.mainCustomerID;
            if (mainCustomerID) {
                try {
                    const hasLytningSubscription = await LytningService.checkLytningSubscription(mainCustomerID);
                    if (hasLytningSubscription) {
                        await Swal.fire({
                            title: 'Lyt-ning Subscription Detected',
                            icon: 'warning',
                            html: '<p>Your account has a Lyt-ning subscription.</p><p>Please use the Lytning platform to access your stores.</p>',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#3085d6'
                        });
                        await context.dispatch('clearStoreState');
                        try {
                            await router.push({name: 'login'});
                        } catch (e) {}
                        // return window.location.reload(true);
                    }
                } catch (error) {
                    console.error('Lyt-ning subscription check failed:', error);
                }
            }

            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `other/getExpiryDate?Database=` + storeDB)
                .then(async ({data}) => {
                    let expireDate = new Date(data);
                    let today = new Date();
                    if (expireDate < today) {
                        // return responses.showWarning(`System Expired!`);
                        return Swal.fire({
                            title: `System Expired ! `,
                            icon: `error`,
                            html: `<p>Please make payment to continue</p>`,
                            showCancelButton: true,
                            confirmButtonText: `Continue`,
                            showLoaderOnConfirm: true,
                            preConfirm: async () => {
                                return context.dispatch(`getPaymentRoute`);
                            }
                        }).then(() => {
                            return Swal.fire({
                                title: `System Expired ! `,
                                icon: `info`,
                                html: `<p>You will be logged out</p> 
                                       <span>You can login again after making payment</span>
                                      `,
                            }).then(() => {
                                return context.dispatch(`clearStoreState`)
                                    .then(async () => {
                                        let deviceID = await Storage.getDeviceID();
                                        localStorage.clear();
                                        await Storage.setDeviceID(deviceID)
                                        try {
                                            await this.$router.push({name: 'login'})
                                        } catch (e) {
                                        }
                                        return window.location.reload(true);
                                    });
                            });
                        })
                    }
                    return context.dispatch(`refreshState`)
                        .then(() => router.push({name: 'StoreLogin'}));
                });
        },
        clearStoreState: async (context) => {
            let mobileUser = await Storage.getMobileUser();
            let deviceID = await Storage.getDeviceID();
            let stores = await Storage.getAllStores();
            localStorage.clear();
            await Storage.setDeviceID(deviceID);
            context.commit(`setAllStores`, stores);
            context.commit(`setMobileUser`, mobileUser)
        },

        /**
         * Build the `?auth=` deeplink payload and open the Franchise
         * Platform in a new tab.
         *
         * <p>Two auth modes are supported, decided by whether the
         * current Vuex state carries an active deeplink sessionId:
         * <ol>
         *   <li><b>Deeplink session mode</b> - the BackOffice was opened
         *       from the source POS via
         *       `?session=<id>&store=<DB>&page=<name>` and
         *       `hydrateFromDeeplinkSession` populated
         *       `state.userModule.deeplinkSession`. The mobileUser written
         *       by hydration is a STUB (fake email, empty password)
         *       and would be rejected by Franchise Tomcat, so we ship
         *       the live `sessionId`/`storeDB` instead. Franchise
         *       Tomcat will validate the sessionId against the same
         *       endpoint it was minted from.</li>
         *   <li><b>Normal-login mode</b> - the BackOffice was opened
         *       directly and `mobileUser` is real. We ship it
         *       unchanged - the historical behaviour.</li>
         * </ol>
         *
         * <p><b>Why `state.userModule.*` and not `state.user.*`?</b><br>
         * The user module is registered as `userModule` in this file's
         * `modules: {}` map (see line ~928) and is NOT namespaced.
         * For non-namespaced Vuex modules, state lives at
         * `state.<moduleKey>.<stateKey>`. So the live path is
         * `state.userModule.deeplinkSession` - NOT `state.user.deeplinkSession`.
         * Do not "fix" this back to `state.user.*` - that path is dead.
         *
         * SECURITY: The `auth.sessionId` is a bearer credential for
         * Franchise Tomcat. It is base64'd into the URL only for the
         * duration of the cross-app redirect and is never persisted
         * here. It is wiped from Vuex state on logout / store-switch
         * via `clearDeeplinkSession`.
         *
         * @param context
         * @param {{name: string, [params]: Object}} [franchiseRoute]
         *   Route inside the Franchise Platform to land on. Defaults
         *   to `{name: 'home'}`.
         * @returns {Promise<void>}
         */
        openFranchisePlatform: async (context, franchiseRoute = {name: 'home'}) => {
            const franchisePlatform = `https://chrilantech.com/Franchise/`;
            const deeplink = (context.getters.getDeeplinkSession
                && typeof context.getters.getDeeplinkSession === 'function')
                ? context.getters.getDeeplinkSession()
                : context.state.userModule
                    && context.state.userModule.deeplinkSession
                    ? context.state.userModule.deeplinkSession
                    : null;
            let payload;
            if (deeplink && deeplink.sessionId && deeplink.storeDB) {
                // Deeplink case: ship the sessionId so Franchise
                // Tomcat validates it directly. The stub mobileUser
                // has no real password.
                payload = {
                    route: franchiseRoute,
                    auth: {
                        sessionId: deeplink.sessionId,
                        storeDB: deeplink.storeDB
                    }
                };
                // eslint-disable-next-line no-console
                console.log('[openFranchisePlatform] using deeplink sessionId', {
                    storeDB: deeplink.storeDB,
                    sessionIdPrefix: String(deeplink.sessionId).slice(0, 8) + '...'
                });
            } else {
                // Normal-login case: existing behaviour unchanged.
                const authUser = await Storage.getMobileUser();
                payload = {
                    route: franchiseRoute,
                    auth: authUser
                };
            }
            console.log(payload);
            return openUrl(franchisePlatform + `?auth=` + window.btoa(JSON.stringify(payload)));
        },
        printInvoice: async (context, invoice) => {
            let storeDB = await Storage.getCurrentStoreDB();
            const baseUrl = '';
            const path = printApi+`Quotes/${storeDB}/invoice`;
            const invoiceNumber = invoice.invoice;  // Unencoded
            const params = {
                PC: 'Online',
                reprint: invoice.reprint
            };

// Encode the invoice number (slashes will become %2F)
            const encodedInvoice = encodeURIComponent(invoiceNumber);

// Build the query string
            const queryString = new URLSearchParams(params).toString();

// Construct full URL
            const fullUrl = `${baseUrl}${path}/${encodedInvoice}?${queryString}`;

            return openUrl(fullUrl)
        },
        printQuote: async (context, saleNumber) => {
            let obj = {
                storeDB: await Storage.getCurrentStoreDB(),
                saleNumber: saleNumber
            };
            return context.dispatch(`printQuoteDB`, obj);
        },

        getOnlineSettings1: async () => {
            let storeDB = await Storage.getCurrentStoreDB();
            // console.log(onlineSalesTomcatApi + `settings/${storeDB}/Online`)
            return axios.get(onlineSalesTomcatApi + `settings/${storeDB}/Online`)
                .then(({data}) => {
                 return data
                }).catch(err => {

                errorHandler.tomcatError(err)
              });
        },

        printQuoteDB: async (context, obj) => {
            let storeDB = obj.storeDB;
            let saleNumber = obj.saleNumber;
            let url = printApi + `Quotes/${storeDB}/${saleNumber}`;
            return openUrl(url);
        },

        printPickingSlip: async (context, saleNumber) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let url = printApi+`debtor/${storeDB}/deliveryNote/${saleNumber}`;
            return openUrl(url);
        },
        async devicecount() {
            try {
                this.storeDB = await Storage.getCurrentStoreDB();
                const response = await axios.get(subscriptionApi + `devices/getResetStatusByStore?DB=${this.storeDB}`);
                this.deviceCountData = response.data;
            } catch (error) {
                // console.error("Error fetching device count:", error);
            } finally {
            }
        },

        async getStoreDetails() {
            this.$utils.showLoading();

            return Promise.all([
                this.$store.dispatch('getCustomerDetails').then((store) => {
                    // console.log(store.Addr3, "this is the stuff");
                }),

            ]).finally(() => {
                this.$utils.hideLoading();
            });
        },
        async validatePCRegistration(context) {
            try {
                // Fetch device count data
                await context.dispatch('devicecount');
                 // Get the necessary details
                const deviceID = await Storage.getDeviceID();
                const store = await Storage.getCurrentStore();

                if (!store) {
                    return { success: true, message: `Success` };
                }

                const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                const screenSize = window.innerWidth <= 768;
                const touchEnabled = "ontouchstart" in window || navigator.maxTouchPoints > 0;

                const mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
                const isMobile = mobileUserAgent || (screenSize && touchEnabled);

                let info;
                // Store isMobile value in local storage
                localStorage.setItem('isMobile', JSON.stringify(isMobile));
                if (!isMobile){
                    try {
                        const response = await axios.get(hardwareApi + 'utils/getPcData');
                        info = response.data?.VOLUMEID || null; // Ensure data is assigned before use
                        if (!info) {
                            responses.showWarning(`Please request for Local Service update`)
                        }
                    }catch (e) {
                        responses.showWarning(`Please request for Local Service update`)
                    }
                }

                const obj = {
                    customerID: store.CustomerID,
                    deviceID: deviceID,
                    isMobile: isMobile,
                    volumeId: info, // Now this.info has data
                    platform: "Online BackOffice",
                };


            // Validate PC Registration
            return axios.get(subscriptionApi + `devices/validatePCRegistration`, {params: obj})
                .then(() => {
                    return {success: true, message: "Success"}
                }).catch((err) => {
                    if (!err.response) {
                        return Swal.fire({
                            icon: "error",
                            title: "Network Error",
                            text: "Please check your internet connection and try again.",
                            confirmButtonText: "OK"
                        });
                    }

                    if (err.response.status === 401 ||err.response.status === 400 || err.response.status === 403) {
                        const errorMessage = `Registration Failed: \n${errorHandler.franchiseLoginError(err)}`;
                        return Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: errorMessage,
                            confirmButtonText: "Reset Devices",
                            showDenyButton: true,
                            denyButtonText: "Buy License",
                            showCancelButton: true,
                            cancelButtonText: "Cancel",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                Swal.fire({
                                    title: 'Enter your UserName',
                                    input: 'text',
                                    inputLabel: 'Username',
                                    showCancelButton: true,
                                    confirmButtonText: 'Submit',
                                    cancelButtonText: 'Cancel',
                                    preConfirm: (username) => {
                                        if (!username) {
                                            Swal.showValidationMessage("Please enter a valid username.");
                                        } else {
                                            return username;
                                        }
                                    },
                                }).then((usernameResult) => {
                                    if (usernameResult.isConfirmed) {
                                        const username = usernameResult.value;
                                        Swal.fire({
                                            title: "Device Management",
                                            html: `
                                    <p><strong>Number of Device Count Resets Remaining:</strong> ${this.deviceCountData.remainingResets}</p>
                                    <p><strong>Number of Device Recounts Done:</strong> ${this.deviceCountData.resets}</p>
                                `,
                                            confirmButtonText: "Reset All",
                                        }).then(async (resetResult) => {
                                            if (resetResult.isConfirmed) {
                                                await context.dispatch('devicecount2', username);
                                            }
                                        });
                                    }
                                });
                            } else if(result.isDenied) {
                                // console.log("this is the link to buy license")
                            }
                        });
                    }

                    return errorHandler.tomcatError(err);
                });
            }catch (e) {

            }
        },
        async devicecount2(context, username) {
            try {
                // Ensure the username is provided
                // console.log(username, "this is the username")
                if (!username) {
                    throw new Error("Username is required for resetting devices.");
                }

                this.storeDB = await Storage.getCurrentStoreDB();

                await axios
                    .post(subscriptionApi + "devices/resetDevices", {
                        user: username, // Use the provided username
                        DB: this.storeDB,
                    })
                    .then((response) => {
                        // console.log("Fetched data:", response.data); // Log the actual response data

                        // Show success message
                        Swal.fire({
                            icon: "success",
                            title: "Success",
                            text: "Device reset was successful!",
                            timer: 2000, // 2 seconds
                            showConfirmButton: false,
                        }).then(() => {
                            // Reload the page after success
                            location.reload();
                        });
                    })
                    .catch((err) => {
                        // Call your error handler
                        errorHandler.tomcatError(err);

                        // Show SweetAlert for the error
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "An error occurred while resetting devices.",
                        });
                    });
            } finally {
                // Optional cleanup logic
            }
        },



        updateToLatestVersion: async () => {
            let store = await Storage.getCurrentStore();
            return axios.put(franchiseTomcatApi + `version/${store.StoreDB}/updateToLatest`);
        },

        getAllDevices: async () => {
            let store = await Storage.getCurrentStore();
            return axios.get(franchiseTomcatApi + `settings/${store.StoreDB}/getAllPCs`)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err));
        },
        getCustomerDetails: async ({}, storeId) => {
            let storeDB = await Storage.getCurrentStoreDB() || storeId?.StoreDB;
            if (!storeDB) return;
            return axios.get(franchiseTomcatApi + `stores/getRegistrationDetails`, {
                params: {database: storeDB}
            }).then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },



        checkSmartInvoicing: async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            let user = await Storage.getCurrentUser();
            return axios.get(franchiseTomcatApi + `GRV/${storeDB}/checkSmartInvoicing`)
                .then(({data}) => {
                    context.commit(`setSmartInvoicingStatus`, data)
                    let isLive = context.getters.getSmartInvoicingLive;
                    if (!data && isLive) {
                        return context.dispatch(`checkIfStoreDocsSubmitted`).then(() => {
                            let hasDocs = context.getters.getDocSubmissionStatus;

                            if (!hasDocs && !!user && router.currentRoute.name !== `userLogin` && router.currentRoute.name !== `login`) {
                                return Swal.fire({
                                    title: 'Register for Smart Invoicing Now',
                                    text: 'You are not registered for smart invoicing. Please register now.',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    showCloseButton: true,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Register',
                                    cancelButtonText: 'Cancel'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        return router.push({name: 'smart-invoicing-setup'});
                                    }
                                });
                            }
                        })
                    }
                }).catch((err) => errorHandler.tomcatError(err))
        },

        getAllPrinters: () => {
            return axios.get(hardwareApi + `utils/getPrinters`)
                .then(({data}) => data)
        },

    },
    modules: {
        stockModule,
        loyaltyModule,
        supplierModule,
        debtorModule,
        userModule,
        stockCategoryModule,
        stockReceiveModule,
        floatModule,
        paymentMethodsModule,
        AssetsModule,
        taxModule,
        timeModule,
        reportsModule,
        stockTakeModule,
        stockLinkingModule,
        securitiesModule,
        stockTransferModule,
        // Settings module is namespaced; register once under 'settings'
        settings: settingsModule,
        coaModule,
        safeModule,
        expenseModule,
        cookingInstruction,
        billingModule,
        mainDebtorModule,
        specialsModule,
        currencyModule,
        deliveryNotesModule,
        emailModule,
        emailModule2,
        ticketModule,cashupsModule,ticket_notes_module,
        subscriptionModule,
        network: networkModule,
        vatCalculator,
        tallyReports,
        'sapInvoices-dashboard': require('./modules/sapInvoices-dashboard').default,
        'sage300Invoices-dashboard': require('./modules/sage300Invoices-dashboard').default,
        integrations: {
            namespaced: true,
            modules: {
                sap: require('./modules/integrations/sap').default,
                sapSync: require('./modules/integrations/sapSync').default,
                sage300: require('./modules/integrations/sage300').default,
                sage300Sync: require('./modules/integrations/sage300Sync').default,
            }
        }
    }
})
